import { checklistAnnouncementsPreworkAndAgenda, completeDeck } from './SL00000Sprint00'
import { basicSlide, bulletListSlide, orderedListSlide, tPrework, tRecap, sprintDemosIntro, sprintDemos } from './SLSprint00'
import { tUnderConstruction } from './SL00000Sprint00'

import { aa_2_1of1_PAaA } from './SL61200Sprint02'
import { list61200Sprint01 } from '../ActivityLists/AL61200Sprint01'

// Software Architecture (SA) module 1 / sprint 1 global values.
const sprint = 1
const activityList = () => { return list61200Sprint01(sprint) }

const aa_1_1of1_PAaA = {
	'prework':[
		'Review Welcome Message',
		'Review Blended Learning & Flipped Classroom',
		'Review Introduction to Scrum',
		'Review Course Syllabus' ],
	'announcements':[ 
		'Welcome!', '',
		'Wednesday’s lecture(s) are recorded',
		'Discord or email are the preferred method of communicating with your Scrum Team' ],
	'agenda':[
		'Progress Polling',
		'Class Format',
		'Introductions - Part 1',
		'Introductions - Part 2 and Scrum Team Assignments',
		'Break',
		'Sprint 1 Planning',
		'Sprint 1 Planning Breakout',
		'Break',
		'Sprint Demos Introduction',
		'Discussion Board 1 as a Scrum Team',
		'Lab',
		'Prework for Next Class',
		'Recap' ]
}

const sprint1_class_1 = (activityList, xyz_1_1of1_PAaA, xyz_2_1of1Prework) => { 
	const poll = () => { return tPrework('Sprint Progress Polling', xyz_1_1of1_PAaA.prework, sprint, activityList) }
	const switchDeck = () => { return bulletListSlide('PowerPoint', 'Switch to PowerPoint slides.', [])}
	const sprintPlanning = () => {
		return orderedListSlide('Sprint Planning', `Sprint ${sprint} Expectations:`, [
			'Similar to other sprints with Discussion, Quiz, Lab, and Reflection',
			'We will complete our scrum team Discussion Board breakout session today',
			`We will have sprint ${sprint-1} Demos and Retrospective next Monday` ])
		
	}
	const activitiesReview = () => {
		return basicSlide('Activity List and Assignments Review', [
			'Let’s open our Blackboard shell and review the activity list and assignments together.' ]
		)
	}
	const shortBreak = () => {
		return basicSlide('Break', [
			'Let’s take a 5 minute break.' ])
	}
	const planningBreakout = () => {
		return orderedListSlide('Sprint Planning Scrum Team Breakout', 'As a scrum team:', [
			`Review sprint ${sprint} activity list & assignments in detail`,
			'Discuss and identify questions/concerns',
			'Scrum master report out by sharing scrum team’s top 2 or 3 questions/concerns' ]
		)
	}
	const recap = () => { return tRecap(xyz_1_1of1_PAaA.agenda.slice(1))}

	const slideDeck = checklistAnnouncementsPreworkAndAgenda(xyz_1_1of1_PAaA, sprint, activityList)
	const preworkNext = () => { return tPrework('Prework For Next Class', xyz_2_1of1Prework, sprint, activityList) }
	return completeDeck(slideDeck, [poll, switchDeck, shortBreak, sprintPlanning, activitiesReview, planningBreakout, sprintDemosIntro, sprintDemos, preworkNext, recap])
}

const aa_1_1of1 = () => { return sprint1_class_1(activityList, aa_1_1of1_PAaA, aa_2_1of1_PAaA.prework) }

export const aa_1_slidedeck = [ aa_1_1of1, [ tUnderConstruction ] ] 